import { render, staticRenderFns } from "./DesignAllowanceApply.vue?vue&type=template&id=05b18041&scoped=true&"
import script from "./DesignAllowanceApply.vue?vue&type=script&lang=js&"
export * from "./DesignAllowanceApply.vue?vue&type=script&lang=js&"
import style0 from "./DesignAllowanceApply.vue?vue&type=style&index=0&id=05b18041&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b18041",
  null
  
)

export default component.exports